import React from "react";
import App from "entry";

import "core-js/es/object";
import "core-js/es/array";

import "./index.css";
import "./i18n/i18n"; 
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
} else {
  console.error('Root container not found');
}